<script setup lang="ts">
/**
 * App Footer Component
 *
 * Footer with company information and links
 */
import { useTranslation } from 'i18next-vue';

const { t } = useTranslation();
const currentYear = new Date().getFullYear();
</script>

<template>
  <div
    class="custom-margin-t px-2 py-3 sm:px-6 lg:px-8"
    style="background: linear-gradient(143deg, var(--color-primary-100) 2.48%, var(--color-profile-50) 56.85%);"
  >
    <!-- custom-margin-t px-4 py-6 sm:px-6 lg:px-8 -->
    <div class="flex flex-col items-center justify-between gap-4 md:flex-row">
      <!-- Left side -->
      <div class="flex flex-col items-center gap-2 md:items-start">
        <p class="custom-footer-left-text text-sm text-gray-600 dark:text-gray-400">
          {{ t('layout.footer', { year: currentYear }) }}
        </p>
        <!-- <p class="text-xs text-gray-500 dark:text-gray-500">
            Version 1.0.0
          </p> -->
      </div>

      <!-- Right side -->
      <div class="flex flex-wrap items-center justify-center gap-3 md:justify-end">
        <a
          href="https://www.timelessmedical.com/privacy/"
          target="_blank"
          rel="noopener noreferrer"
          class="custom-footer-right-text footer-link"
        >
          {{ t('auth.privacyPolicy') }}
        </a> |
        <a
          href="https://www.timelessmedical.com/terms-conditions/"
          target="_blank"
          rel="noopener noreferrer"
          class="custom-footer-right-text footer-link"
        >
          {{ t('auth.termsOfService') }}
        </a> |
        <a
          href="https://www.timelessmedical.com/support/"
          target="_blank"
          rel="noopener noreferrer"
          class="custom-footer-right-text footer-link"
        >
          {{ t('auth.support') }}
        </a>
        <!-- <a href="#" class="text-sm text-gray-600 hover:text-primary-600 dark:text-gray-400 dark:hover:text-primary-400 transition-colors">
            Documentation
          </a> -->
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-margin-t {
  margin-top: 1.9rem;
  position: fixed;
  bottom: 0;
  width: 100%;
}

.custom-footer-left-text {
  color: var(--color-gray-900);
  font-weight: 500;
  line-height: 20px;
  font-size: 0.875rem;
}

.custom-footer-right-text {
  color: var(--color-primary-600);
  font-weight: 500;
  line-height: 20px;
  font-size: 0.875rem;
}

.footer-link {
  cursor: pointer;
}

.footer-link:hover {
  text-decoration: underline;
}
</style>
